<template>
  <div class="home-container">
    <!-- 头部图片 -->
    <van-image
      width="100"
      height="100"
      src="https://zcqh-1300413120.cos.ap-shanghai.myqcloud.com/Open_Account/img/fb98dbdd-80ff-4643-85dc-20e51d88b810.jpg"
      fit="contain"
    />
    <!-- 表单区域 -->
    <van-form @submit="onSubmit">
      <div class="form-text">期货免费开户</div>
      <!-- 表单区域 -->
      <van-field
        v-model="realName"
        name="姓名"
        label="姓名"
        placeholder="请输入姓名"
        :rules="[{ required: true, message: '请输入姓名' }]"
      />
      <van-field
        v-model="mobile"
        name="手机号"
        label="手机号"
        placeholder="请输入手机号"
        :rules="[{ pattern, message: '请输入正确手机号' }]"
      />
      <div class="piccode-wrap">
        <van-field
          v-model="picCode"
          name="验证码"
          label="验证码"
          placeholder="请输入验证码"
          :rules="[{ required: true, message: '请输入验证码' }]"
        />
        <van-image :src="picCodeImg"  @click="onChanePicCode"></van-image>
      </div>
      <div class="info-prot">
        <van-checkbox
          v-model="checked"
          shape="square"
          @change="change"
          icon-size="0.4rem"
        >
          <span class="port-info-1">我已阅读并同意</span>
          <span class="port-info-2">《个人信息授权与保护声明》</span>
        </van-checkbox>
      </div>

      <div style="margin: 16px">
        <van-button
          round
          block
          type="info"
          native-type="submit"
          class="fireworks"
          >预约开户</van-button
        >
      </div>
    </van-form>
    <!-- 信息授权声明 -->
    <!--《个人信息授权与保护声明》面板-->
    <van-action-sheet
      v-model="showAction"
      title="个人信息授权与保护声明"
      cancel-text="我已阅读并同意"
      :closeable="false"
      :close-on-click-overlay="false"
      @cancel="onActionCancel"
    >
      <div class="action-content">
        <hr />
        <p>尊敬的用户：</p>
        <p>
          1、本服务页面及本协议由本页面的实际运营者，即中财期货有限公司（以下简称“我方”）提供。
        </p>
        <p>
          2、我方将按照法律规定收集、处理您的个人信息。本协议可能涉及您个人信息权益的重要约定，请您在提供个人信息前仔细阅读。一旦您在页面上提交了相关信息，即视为您同意本协议的全部内容。
        </p>
        <p>
          3、为了进一步向您提供商品或服务的相关信息，了解您的需求以更好地实现本广告的推广目的，需要您按页面的表单提交相关信息（简称“客户信息”），提交的可能包括您的姓名、电话、邮箱、地址信息，具体以页面展示的为准，我们使用前述信息的目的在于与您联络，向您介绍我方提供的具体商品或服务，或为您提供客服。您有权拒绝提供上述信息，但可能无法获取进一步的广告服务。如您提供了上述信息，您应保证所有信息真实、准确、完整、有效。
        </p>
        <p>
          4、您同意我方可基于以下目的或原因委托、安排第三方对您的个人信息进行收集和/或处理（这些第三方主要包括我们的经销商、广告服务合作方、客服服务商、数据分析服务商等）：（1）安排销售人员与您取得联系，向您提供更有价值的信息，实现广告推广目的；（2）用于广告投放、广告投放效果优化、广告归因、广告监测等广告业务合作；（3）用于商业性分析和洞察；（4）核验信息真实性；（5）其他法律法规许可的目的。我方会要求这些第三方按照不低于我方的安全标准保护您的客户信息。
        </p>
        <p>
          5、我方将采取有效措施保障您的个人信息安全，因我方及我方委托的第三方收集、处理您的个人信息产生的一切问题，由我方处理、负责。
        </p>
        <p>
          6、若您是未满18周岁的未成年人，请在您的父母或其他监护人监护、指导下共同阅读本协议。
        </p>
        <p>
          7、如您有任何投诉、建议或咨询，或有任何基于法律法规规定的权利请求，例如查询、修改、删除、撤回授权等，请通过以下方式联系我方：<em
            style="color: #4879aa"
            >400-888-0958</em
          >。
        </p>
        <p>中财期货有限公司</p>
      </div>
    </van-action-sheet>

    <!-- 开户流程图 -->
    <div class="khlc-container">
      <img width="100%" src="../assets/kh_lc.jpg" />
    </div>

    <!-- 开户公司介绍图 -->
    <div class="gsjs-container">
      <img width="100%" src="../assets/kh_gsjs.jpg" />
    </div>

    <!-- 开户中财优势图 -->
    <div class="zcys-container">
      <img width="100%" src="../assets/kh_zcys.jpg"/>
    </div>

    <!-- 声明部分 -->
    <div class="shengming">
      <p>投资有风险，入市需谨慎</p>
      <p>电话：400-888-0958</p>
      <p>地址：上海市浦东新区陆家嘴环路958号华能联合大厦23楼</p>
      <p>Copyright © 中财期货有限公司</p>
    </div>

    <!-- 底部button -->
    <div class="bottom-container">
      <div class="bottom-left">
        <van-button @click="showEwmAction = true">人工客服</van-button>
      </div>
      <a class="bottom-right" href="tel:13310198658" ref="telPhone">
        <van-button @click="clickPhone">电话咨询</van-button>
      </a>
    </div>

    <!-- 客户经理微信二维码弹出窗口 -->
    <van-action-sheet
      v-model="showEwmAction"
      title="客户经理二维码"
      @cancel="onEwmActionCancel"
      class="ewmAction"
    >
      <div class="action-content">
        <img src="../assets/ewm_sk.jpg" alt="" />
      </div>
    </van-action-sheet>
  </div>
</template>

<script>
import { addKhUser } from "@/api";
import Crypto from '@/utils/crypto.js'
export default {
  data() {
    return {
      bannerImg: "@/assets/kh_banner.jpg",
      realName: "",
      mobile: "",
      channel: -1,
      pattern: /^[1][2-9]{1}[0-9]{9}$/,
      checked: false,
      showAction: false,
      showEwmAction: false,
      picCodeImg: "",
      picCode:""
    };
  },
  methods: {
    // 拨打电话
    clickPhone() {
      this.$dialog
        .confirm({
          title: "提示",
          message: "确定拨打客服电话？",
          confirmButtonColor: "#09BB07",
        })
        .then(() => {
          // on confirm
          this.$refs.telPhone.click();
        })
        .catch(() => {
          // on cancel
        });
    },
    async onSubmit(values) {
      // console.log('submit', values);
      // 1. 先确认是否点击了阅读
      if (!this.checked) {
        this.$toast("请先阅读《个人信息授权与保护声明》");
        return;
      }
      // 发送请求
      // console.log(this.mobile, this.realName, this.channel, this.picCode);
      let aes_mobile = Crypto.encrypt(this.mobile)
      // console.log(aes_mobile);
      // this.$dialog({message: aes_mobile})
      // this.$toast(aes_mobile)
      const res = await this.$api.add(
        aes_mobile,
        this.realName,
        this.channel,
        this.picCode
      );
      if (res.data.code == 200) {
        this.$toast("已成功预约！");
      } else {
        this.$toast(res.data.message);
      }

      // console.log(res.data);
    },
    change(e) {
      if (e) {
        // 如果选中，则弹出告知窗口
        this.showAction = true;
      }
    },
    //
    onActionCancel(e) {
      console.log(e);
      this.showAction = false;
    },
    onEwmActionCancel() {
      this.showEwmAction = false;
    },
    getUrlParamsFn() {
      const urlParams = new URLSearchParams(window.location.search);
      const urlhash = new URLSearchParams(window.location.hash.split("?")[1]);
      // console.log("urlParams=", urlParams.get("channel"));
      // console.log("urlhash=", urlhash.get("channel"));
      let channel = urlParams.get("channel") || urlhash.get("channel");
      console.log("channel=", channel);
      if (typeof channel !== "undefined" && channel != null) {
        this.channel = parseInt(channel);
      } else {
        this.$toast("url地址未携带channel参数！");
      }
      // console.log(this.channel);
    },
    // 获取图片验证码
    async getPicCodeFn() {
      const res = await this.$api.getPicCode();
      console.log(res.data);
      if (res.data.code == 200) {
        this.picCodeImg = res.data.data.codePic;
      } else {
        this.$toast("获取图片验证码失败！");
      }
    },
    // 点击切换图片验证码
    onChanePicCode() {
      this.getPicCodeFn();
    },
  },
  mounted() {
    // 1. 获取链接参数
    this.getUrlParamsFn();
    // 2. 获取图形验证码
    this.getPicCodeFn()
  },
};
</script>

<style lang="less" scoped>
.home-container {
  padding-bottom: 50px;
  .van-image {
    width: 100% !important;
    height: 100% !important;
  }
  .van-form {
    .form-text {
      display: flex;
      padding-left: 16px;
      font-size: 14px;
      line-height: 24px;
      color: #ed3b3b;
    }
    .info-prot {
      font-size: 0.3rem;
      padding-left: 16px;
      padding-top: 4px;
      .van-checkbox {
        .port-info-1 {
          color: #ed3b3b;
        }
        .port-info-2 {
          color: #4879aa;
        }
      }
    }
    .piccode-wrap {
      display: flex;
      align-items: center;
      .van-field {
        flex: 2;
      }
      .van-image {
        flex: 1;
        padding-right: 6px;
      }
    }
  }
  .van-action-sheet__header {
    // font-size: 14px;
    color: #333;
    // line-height: 1rem;
  }
  .action-content {
    color: #666;
    text-align: left;
    padding: 0 6px;

    p {
      margin-block-start: 0;
      margin-block-end: 0;
      margin-top: 0.2rem;
    }
    p:last-child {
      text-align: right;
      padding-right: 10px;
    }
  }
  .van-action-sheet__cancel {
    background-color: #4093e3;
    color: #fff;
    font-family: "Microsoft Yahei", sans-serif, -apple-system, Helvetica, Arial;
  }
  .shengming {
    padding: 10px 5px;
    background-color: #346a9d;
    color: #eee;
    font-size: 12px;
  }
  .ewmAction {
    .action-content {
      display: flex;
      justify-content: center;
      img {
        width: 60%;
        height: 60%;
      }
    }
  }

  .bottom-container {
    position: fixed;
    bottom: 0px;
    left: 0px;
    width: 100%;
    height: 50px;
    background-color: #4093e3;
    display: flex;
    .bottom-left {
      flex: 1;
    }
    .bottom-right {
      flex: 1;
    }
    .van-button {
      width: 100%;
      height: 100%;
      background-color: #4093e3;
      color: #fff;
    }
  }
}
</style>